import { processAffiliateData } from "../utils/helpers.js";
import { supabase } from "../lib/supabase.js"; // adjust if needed

// 3. Table names
const AFFILIATE_ENTITY_TABLE = "affiliate_entity";
const AFFILIATE_EARNINGS_SUMMARY_TABLE = "affiliate_earnings_summary";

export const safeNumber = (val) =>
  val === "" || val === null || val === undefined ? 0 : Number(val);

// 4. Main processing function
export async function processHistoricalData(allData) {
  console.log(`Total rows: ${allData.length}`);

  // 3. Summarize using shared logic
  const { affiliates } = processAffiliateData(allData);

  // 4.3 Upsert affiliates
  const affiliateEntities = affiliates.map((a) => ({
    name: a.name,
    // id will be auto-generated or handled by Supabase
  }));
  // Deduplicate by name
  const uniqueAffiliateNames = Array.from(
    new Set(affiliateEntities.map((a) => a.name))
  ).map((name) => ({ name }));

  // Upsert affiliate entities
  let { error: affiliateError, data: affiliateData } = await supabase
    .from(AFFILIATE_ENTITY_TABLE)
    .upsert(uniqueAffiliateNames, { onConflict: ["name"] })
    .select("*");
  if (affiliateError) throw affiliateError;

  // 4.4 Upsert affiliate earnings summary (ad-wise, affiliate-wise)
  let outRows = [];
  for (const item of affiliates) {
    const affiliateId = affiliateData.find((a) => a.name === item.name)?.id;
    for (const ad of item.ads) {
      outRows.push({
        affiliate_id: affiliateId,
        affiliate_name: item.name,
        ad_name: ad.adName,
        ad_spend: safeNumber(ad.adSpend),
        revenue: safeNumber(ad.revenue),
        roas: safeNumber(ad.roas),
        profit: safeNumber(ad.profit),
        commission: safeNumber(ad.commission),
        purchases: safeNumber(ad.purchases),
        cpa: safeNumber(ad.cpa),
        aov: safeNumber(ad.aov),
        campaign_name: ad.campaignName,
        adset_name: ad.adsetName,
        commission_tier: ad.commissionTier ?? null,
        commission_label: ad.commissionLabel ?? null,
      });
    }
  }

  // Upsert summary rows (adjust onConflict as needed)
  let { error: summaryError } = await supabase
    .from(AFFILIATE_EARNINGS_SUMMARY_TABLE)
    .upsert(outRows, {
      onConflict: ["affiliate_name", "ad_name"],
    });
  if (summaryError) throw summaryError;

  console.log("Historical data processed and upserted successfully.");
}
